import * as React from 'react';

import { DarkConcentrationSvg, GrayConcentrationSvg, LightConcentrationSvg } from '../../Svg';

interface SvgInjectedProps {
    className?: string;
}
interface Props {
    themeMode?: 'dark' | 'gray' | 'light';
    className: string;
}
export default class ConcentrationIcon extends React.PureComponent<Props> {
    static defaultProps = {
        className: '',
        themeMode: 'dark',
    };

    render() {
        const { themeMode, className } = this.props;

        let classNames: Array<string> = [className, 'ddbc-concentration-icon'];

        let SvgIcon: React.ComponentType<SvgInjectedProps> | null = null;

        switch (themeMode) {
            case 'light':
                SvgIcon = LightConcentrationSvg;
                break;
            case 'gray':
                SvgIcon = GrayConcentrationSvg;
                break;
            case 'dark':
            default:
                SvgIcon = DarkConcentrationSvg;
        }

        if (SvgIcon === null) {
            return null;
        }

        return <SvgIcon className={classNames.join(' ')} />;
    }
}
